import type { FoodAverageCaloriesInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

export function FoodAverageCalories(props: TileProps<FoodAverageCaloriesInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const days = range / 24

  const { foodCalculations } = useCalculationsContext()
  const { totalCalories } = foodCalculations[range] || {}

  const value = totalCalories === undefined ?
    NaN :
    round(totalCalories / days)

  const unit = polyglot.t(
    "unit.calories",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
